import { render, staticRenderFns } from "./CustomFormBtnDialog.vue?vue&type=template&id=c4815f3c"
import script from "./CustomFormBtnDialog.vue?vue&type=script&lang=js"
export * from "./CustomFormBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports